import { CookieNames } from '../constants';
import type { CookieClient } from '../types';

export default class LoginCookie {
  private path = '/';

  constructor(private cookieClient: CookieClient) {}

  get hasAccessTokenCookie() {
    return Boolean(this.cookieClient.get(CookieNames.CVAccessToken));
  }

  get hasLoginCookie() {
    return this.cookieClient.get(CookieNames.MerchHasLoggedIn) === 'true';
  }

  get shouldSetCookie() {
    return this.hasAccessTokenCookie && !this.hasLoginCookie;
  }

  get shouldRemoveCookie() {
    return this.hasLoginCookie && !this.hasAccessTokenCookie;
  }

  set(): void {
    this.cookieClient.set(CookieNames.MerchHasLoggedIn, 'true', {
      path: this.path
    });
  }

  remove(): void {
    this.cookieClient.set(CookieNames.MerchHasLoggedIn, '', {
      expires: 'Thu, 01 Jan 1970 00:00:00 UTC',
      path: this.path
    });
  }
}
